import React, { SetStateAction } from "react";
import {
	Box,
	AccordionDetails,
	AccordionSummary,
	FormGroup,
} from "@mui/material";
import { StyledAccordion } from "../../../pricing_list/components/TenderSection/StyledAccordion";
import { CustomToggleButtonGroup } from "../../../../common/components/ToggleButtonGroup/ToggleButtonGroup";
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import FilePresentIcon from '@mui/icons-material/FilePresent';

interface ViewTypeSelectorProps {
	readonly currentView: "ByQuery" | "ByContract";
	readonly setCurrentView: React.Dispatch<SetStateAction<"ByQuery" | "ByContract">>;
}

export function ViewTypeSelector({
	currentView,
	setCurrentView,
}: ViewTypeSelectorProps) {
	return (
		<Box>
			<StyledAccordion expanded={true}>
				<AccordionSummary>
					<span>View Type</span>
				</AccordionSummary>
				<AccordionDetails>
					<FormGroup >
						<CustomToggleButtonGroup
							sx={{
								width: 300,
								height: 61,
								color: "#171D21",
							}}
							groupValue={currentView}
							onValueChange={(value) => setCurrentView(value)}
							groupLabel="by-contract-by-query"
							buttonValues={["ByQuery", "ByContract"]}
							displayValues={[<><DeviceHubIcon/> View by query</>, <><FilePresentIcon /> View by contract</>]}
						/>
					</FormGroup>					
				</AccordionDetails>
			</StyledAccordion>
		</Box>
	);
}
